import React, { useState } from 'react';

const ProductForm = ({
  setProductDetailsParent,
  setSection,
  formTextboxContainer,
  formTextboxLabel,
  formTextbox,
  formTextarea,
  orangeButton
}) => {
  // State for product details
  const [productDetails, setProductDetails] = useState({
    serviceSpecialties: '',
    serviceDescription: '',
    servicePlanDescription: '',
  });

  // State for form errors
  const [formErrors, setFormErrors] = useState({});

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProductDetails({
      ...productDetails,
      [name]: value,
    });
    validateField(name, value);
  };

  // Validate individual fields
  const validateField = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'serviceSpecialties':
        errors.serviceSpecialties = value.trim() === '' ? 'Service Specialties is required' : '';
        break;
      case 'serviceDescription':
        errors.serviceDescription = value.trim() === '' ? 'Service Description is required' : '';
        break;
      case 'servicePlanDescription':
        errors.servicePlanDescription = value.trim() === '' ? 'Service Plan Description is required' : '';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  // Validate all fields on form submission
  const validateAllFields = () => {
    const errors = {};

    if (productDetails.serviceSpecialties.trim() === '') {
      errors.serviceSpecialties = 'Service Specialties is required';
    }

    if (productDetails.serviceDescription.trim() === '') {
      errors.serviceDescription = 'Service Description is required';
    }

    if (productDetails.servicePlanDescription.trim() === '') {
      errors.servicePlanDescription = 'Service Plan Description is required';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateAllFields()) {
      setProductDetailsParent(productDetails);
      setSection(2); // Proceed to the next section
    }
  };

  return (
    <div className="container px-4 pb-4">
      <form noValidate>
        {/* Service Specialties */}
        <div className="form-group mb-4">
          <label className={formTextboxLabel}>
            Service Specialties <span style={{ color: '#9a016a' }}>*</span>
          </label>
          <input
            type="text"
            name="serviceSpecialties"
            value={productDetails.serviceSpecialties}
            onChange={handleInputChange}
            className={`form-control ${formErrors.serviceSpecialties ? 'is-invalid' : ''}`}
            placeholder="Service Specialties"
            required
            style={{ borderRadius: '0' }}
          />
          <div className="invalid-feedback">{formErrors.serviceSpecialties}</div>
        </div>

        {/* Service Description */}
        <div className="form-group my-4">
          <label className={formTextboxLabel}>
            Service Description <span style={{ color: '#9a016a' }}>*</span>
          </label>
          <input
            type="text"
            name="serviceDescription"
            value={productDetails.serviceDescription}
            onChange={handleInputChange}
            className={`form-control ${formErrors.serviceDescription ? 'is-invalid' : ''}`}
            placeholder="Service Description"
            required
            style={{ borderRadius: '0' }}
          />
          <div className="invalid-feedback">{formErrors.serviceDescription}</div>
        </div>

        {/* Service Plan Description */}
        <div className="form-group my-4">
          <label className={formTextboxLabel}>
            Goal <span style={{ color: '#9a016a' }}>*</span>
          </label>
          <textarea
            name="servicePlanDescription"
            value={productDetails.servicePlanDescription}
            onChange={handleInputChange}
            className={`form-control ${formErrors.servicePlanDescription ? 'is-invalid' : ''}`}
            placeholder="Describe how you plan to serve CharmHealth customers here"
            required
            style={{ borderRadius: '0' }}
          />
          <div className="invalid-feedback">{formErrors.servicePlanDescription}</div>
        </div>

        {/* Buttons */}
        <div className="flex flex-row justify-between pb-8">
          <button
            type="button"
            className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2"
            onClick={() => setSection(0)}
          >
            Back
          </button>

          <button
            type="button"
            className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2"
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;